import React,{useEffect,useState,useRef} from 'react';
import { useLocation } from 'react-router-dom';
import './Video.css';
import { MdClose } from 'react-icons/md';
import { IoPlay } from 'react-icons/io5';

const VideoWidget=()=>{
    const [isOpen,SetIsOpen]=useState(true);
    

      useEffect(() => {
    const handleCloseVideo = () => {
      SetIsOpen(false);
    };

    window.addEventListener("closeVideo", handleCloseVideo);

    return () => {
      window.removeEventListener("closeVideo", handleCloseVideo);
    };
  }, []);
    const toggleVideo=()=>{
         const opening = !isOpen;

  if (opening) {
    
    window.dispatchEvent(new Event("closeChat"));
  }

  SetIsOpen(opening);
    };

    const closeVideo=()=>{
        SetIsOpen(false);
       
    };
    const location = useLocation();

  
  const hidePages = ["/login-page", "/dashboard", "/results","/admin-panel"];

  if (hidePages.includes(location.pathname)) {
    return null;
  }


return(
    <>
   <div className="video-button" onClick={toggleVideo}>
        {/* <span className="video-tooltip">Campus Tour</span> */}
       <IoPlay className="play-icon"  size={20}   />
       {/* <span style={{ color: "#00134d", fontSize: "20px" }}>▶</span> */}
      </div>

      {/* Video Popup */}
      <div className={`video-container ${isOpen ? "open" : ""}`}>
        <div className="video-header">
            <div className='Video-head'>
          {/* <span>PLATINUM JUBILEE YEAR</span> */}
          <h5>PLATINUM JUBILEE YEAR</h5>
          </div>

          <MdClose 
  className="close-btn" 
  onClick={closeVideo} 
/>
          
        </div>

        <div className="video-body">
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/D15uUuNgxRI?si=t_bd04kiY6NWm7BT"
            title="YouTube video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <div className="About-Acgcet">
        <h5>ABOUT ACGCET</h5>
        </div>
      </div>

    
    </>
)
};
export default VideoWidget;